import { getNumberFormat } from "./numberFormats";

export interface FormatNumericValueOptions {
    locale?: string;
    /**
     * Catalogue id from `utils/numberFormats` — "dollar", "euro", "percent",
     * "number_with_commas", … Legacy values ("currency") still resolve.
     */
    numberFormat?: string;
    decimalPlaces?: number;
}

export const formatNumericValue = (
    value: any,
    options?: FormatNumericValueOptions
): string => {
    let num = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(num)) {
        return String(value);
    }

    // Handle decimal places
    if (typeof options?.decimalPlaces === "number") {
        const multiplier = Math.pow(10, options.decimalPlaces);
        num = Math.round(num * multiplier) / multiplier;
    }

    // Format as string with locale and precise decimal places
    let formatted = options?.locale
        ? num.toLocaleString(options.locale, {
            minimumFractionDigits: options?.decimalPlaces,
            maximumFractionDigits: options?.decimalPlaces,
        })
        : num.toLocaleString(undefined, {
            minimumFractionDigits: options?.decimalPlaces,
            maximumFractionDigits: options?.decimalPlaces,
        });

    // Apply the catalogue's symbol and placement. Unknown ids and the plain
    // number formats fall through with the digits untouched.
    const def = getNumberFormat(options?.numberFormat);
    if (!def || def.position === "none" || !def.symbol) {
        return formatted;
    }

    if (def.position === "prefix") {
        return `${def.symbol}${formatted}`;
    }

    // Percent hugs the digits ("50%"); trailing currency symbols read as a
    // separate word ("1,234 kr"), which is how those locales write them.
    return def.id === "percent"
        ? `${formatted}${def.symbol}`
        : `${formatted} ${def.symbol}`;
};
